import API from "./API";
import {
  Order,
  OrderFilters,
  OrdersResponse,
  StripeOrdersResponse,
  StripeOrderDetailsResponse,
} from "../../Types/Dashboard";

class OrderService extends API {
  static getOrders = (
    filters?: OrderFilters
  ): Promise<{ data: OrdersResponse }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);

    const queryString = params.toString();
    return this.getRequest(
      `admin/orders${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: OrdersResponse }>;
  };

  static getStripeOrders = (
    filters?: OrderFilters
  ): Promise<{ data: StripeOrdersResponse }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);

    const queryString = params.toString();
    return this.getRequest(
      `admin/stripe-orders${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: StripeOrdersResponse }>;
  };

  static getOrderDetails = (
    id: number
  ): Promise<{ data: { order: Order } }> => {
    return this.getRequest(`admin/orders/${id}`, true) as unknown as Promise<{ data: { order: Order } }>;
  };

  static getStripeOrderDetails = (
    id: number
  ): Promise<{ data: StripeOrderDetailsResponse }> => {
    return this.getRequest(`admin/stripe-orders/${id}`, true) as unknown as Promise<{ data: StripeOrderDetailsResponse }>;
  };

  static updateOrderStatus = (
    id: number,
    status: string
  ): Promise<{ status: string }> => {
    return this.putRequest(`admin/orders/${id}`, { status }, true) as unknown as Promise<{ status: string }>;
  };

  static deleteOrder = (id: number): Promise<{ status: string }> => {
    return this.deleteRequest(`admin/orders/${id}`, {}, true) as unknown as Promise<{ status: string }>;
  };
}

export default OrderService;
